import { highlightBrowserLog } from './log'

export const swiftCustomEventName = 'swiftCustomEvent'

export function dispatchSwiftCustomEvent(args: any) {
  try {
    if (Array.isArray(args)) {
      args.forEach((arg) => {
        const pushGTM = new CustomEvent(swiftCustomEventName, {
          detail: {
            name: arg.event,
            data: args,
          },
        })

        document.dispatchEvent(pushGTM)
      })

      return
    }

    if (args.constructor === Object) {
      const pushGTM = new CustomEvent(swiftCustomEventName, {
        detail: {
          name: args.event,
          data: args,
        },
      })

      document.dispatchEvent(pushGTM)
    }

    highlightBrowserLog(swiftCustomEventName, { args })
  } catch (e) {
    highlightBrowserLog(swiftCustomEventName, { error: JSON.stringify(e) })
  }
}
